/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetGetProductPriceListQueryResponse, GetGetProductPriceListPathParams, GetGetProductPriceListQueryParams } from "../../models/GetGetProductPriceList";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetGetProductPriceListUrl({ debtorCode }: { debtorCode: GetGetProductPriceListPathParams["debtorCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/product-price-list` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/product-price-list}
 */
export async function getGetProductPriceList({ debtorCode, params }: { debtorCode: GetGetProductPriceListPathParams["debtorCode"]; params: GetGetProductPriceListQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetGetProductPriceListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetGetProductPriceListUrl({ debtorCode }).url.toString(), params, ... requestConfig })  
  return res.data
}